import { useEffect } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';

// Steps past Amplify's "Account recovery requires verified contact information"
// screen (#1044).
//
// Email sign-ups are confirmed without proving the address (#697), so their
// email_verified is false. After an email sign-in or sign-up, Amplify UI's machine
// finds that and moves to its verify step, route 'verifyUser'. The machine has no user
// on that step, so AuthPage's "signed in, move on" never fired: /login showed Amplify's
// stock screen, and anyone who left through the header instead of its Skip link left
// the machine parked in a state that ignores SIGN_OUT. Sign Out (and Delete Account's
// sign-out) then did nothing until the page was reloaded. Nothing here wants that
// screen: VerifyEmailInline asks for verification with the same Cognito calls.
//
// skipVerification sends the SKIP the screen's own Skip button sends. The machine
// goes on to authenticated, where signing out works; the address stays unverified and
// the banner still asks for it. Mounted once, inside Authenticator.Provider.
const SkipContactVerification = () => {
  const { route, skipVerification } = useAuthenticator((context) => [context.route]);
  useEffect(() => {
    if (route === 'verifyUser') skipVerification();
  }, [route, skipVerification]);
  return null;
};

export default SkipContactVerification;
